import React, {CSSProperties, Ref} from 'react';

import classnames from 'classnames';
import styles from './styles.scss';
import {useTranslation} from 'react-i18next';

//TODO переробити на клас і з'єднати з textarea

//TODO add events
type P = {
    placeholder?:string;
    className?:string;
    value?:string|number;
    style?:CSSProperties;
    type?:string;
    required?:boolean;

    labelText?:string;
    labelClass?:string;
    labelStyle?:CSSProperties;

    containerClass?:string;
    containerStyle?:CSSProperties;
    onChange?:Function;

    error?:boolean;
    errorText?:string;
    errorClass?:string
};

export const Input = React.forwardRef((props:P, ref:Ref<any>) => {
    const {t} = useTranslation('common');

    const {type = 'text', style = {}, required = false} = props;

    const onChange = (e) => {
        if (typeof props.onChange === 'function') {
            props.onChange(e);
        }
    };

    const errorText = props?.errorText ||  (props.required ? t('errorInput') : '');

    return <div style={props?.containerStyle || {}}
        className={classnames(styles.defaultContainer, props?.containerClass || '', props.error ? styles.error : '')}>

        {props.labelText && <label
            style={props?.labelStyle || {}}
            className={props.labelClass}>
            {props.labelText}
        </label>}

        <input
            onChange={onChange}
            placeholder={props.placeholder}
            value={props.value}
            className={props.className}
            style={style}
            type={type}
            required={required}
            ref={ref}
        />

        {errorText && props.error && <div className={classnames(styles.errorText, props.errorClass)}>
            {errorText}
        </div>}
    </div>;
});